module.exports = __webpack_public_path__ + "static/media/life.377f83d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/life.svg
// module id = 3000
// module chunks = 0